import React, { useEffect } from 'react';
import { Grid, TextField,FormControl, Button,  Box, Autocomplete, InputLabel, Select, MenuItem
} from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const PropertyInfo = ({cities, onSuccess, propertyData={} }) => {

  const defaultValues = {
    city:null,
    name: '',
    type: 'Library',
  };

  /** Hooks */
  const { handleSubmit, control, formState: { errors }, reset } = useForm({
    mode: 'onTouched',
    defaultValues
  });


  useEffect(() => {
    if(propertyData){
      const {name, city, type} = propertyData;
      reset({name, city, type});
    }
    return () => {};
  }, [propertyData, reset]);


  const onSubmit = (data) => {
    onSuccess(data)
  }

  return (
    <Box sx={{ mb: 2, mt:4, px: 4 }} noValidate component="form"  onSubmit={handleSubmit(onSubmit)} >
      <Grid container justifyContent="center">
        <Grid container  item xs={12} sm={12} md={6} lg={5}>
        <Grid item xs={12} sm={12} md={12} lg={12}  sx={{mt: 1.9}}>
            <Controller
              control={control}
              name="city"
              id="city"
              rules={{ required: "Select property city" }}
              required
              render={({field }) => (
                <Autocomplete
                  {...field}
                  required
                  disablePortal
                  size="small"
                  options={cities}
                  fullWidth={true}
                  // value={selectedCity}
                  isOptionEqualToValue={(option, value) => option === value}
                  onChange={(event, newValue) => {field.onChange(newValue)}}
                  renderInput={(params) => <TextField {...params} error={!!errors?.city} required label="City" />}
                />
              )}
              onChange={([, data]) => data}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}   sx={{mt: 2}}>
            <Controller
              control={control}
              name="name"
              id="name"
              rules={{ required: "Enter your property name" }}
              render={({field }) => (
                <TextField
                  {...field}
                  margin="normal"
                  fullWidth
                  size="small"
                  label="Property Name"
                  required
                  error={!!errors?.name}
                  // helperText={errors.firstName?.message}
                />
              )}
            />
          </Grid>
          
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 3}}>
            <Controller
              control={control}
              required
              name="type"
              id="type"
              rules={{ required: "Select property type" }}
              render={({field }) => (
                <FormControl {...field} fullWidth error={!!errors?.type}>
                  <InputLabel id="type-label" size="small" required>Property Type</InputLabel>
                  <Select    
                    name="type"                 
                    labelId="type-label"
                    id="type-select"
                    label="Property Type"
                    size="small"
                    {...field}
                  >
                    <MenuItem value="Library">Library</MenuItem>
                    {/* <MenuItem value="Coaching Center">Coaching Center</MenuItem>
                    <MenuItem value="PG">PG</MenuItem> */}
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
        </Grid>
        
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            type="submit" 
            variant="contained"
            sx={{ mt: 4, mb: 2 }}
            endIcon={<ArrowForwardIosIcon />}
            color="warning"
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
      
  );
}
 
export default React.memo(PropertyInfo);
